import i18n from "@/i18n";
import { showMessage } from "@/services/MessageService";

const handleLoginError = (error) => {
  switch (error) {
    case "auth/invalid-email":
      showMessage({
        title: i18n.global.t("login.errorsLogin.invalidEmail.title"),
        message: i18n.global.t("login.errorsLogin.invalidEmail.message"),
        type: "error",
      });
      break;
    case "auth/user-not-found":
      showMessage({
        title: i18n.global.t("login.errorsLogin.userNotFound.title"),
        message: i18n.global.t("login.errorsLogin.userNotFound.message"),
        type: "error",
      });
      break;
    case "auth/wrong-password":
      showMessage({
        title: i18n.global.t("login.errorsLogin.wrongPassword.title"),
        message: i18n.global.t("login.errorsLogin.wrongPassword.message"),
        type: "error",
      });
      break;
    case "auth/account-exists-with-different-credential":
      showMessage({
        title: i18n.global.t(
          "login.errorsLogin.accountExistsDifferentCredential.title"
        ),
        message: i18n.global.t(
          "login.errorsLogin.accountExistsDifferentCredential.message"
        ),
        type: "error",
      });
      break;
    case "auth/operation-not-allowed":
      showMessage({
        title: i18n.global.t("login.errorsLogin.operationNotAllowed.title"),
        message: i18n.global.t("login.errorsLogin.operationNotAllowed.message"),
        type: "error",
      });
      break;
    case "auth/user-disabled":
      showMessage({
        title: i18n.global.t("login.errorsLogin.userDisabled.title"),
        message: i18n.global.t("login.errorsLogin.userDisabled.message"),
        type: "error",
      });
      break;
    case "auth/invalid-verification-id":
      showMessage({
        title: i18n.global.t("login.errorsLogin.invalidVerificationID.title"),
        message: i18n.global.t(
          "login.errorsLogin.invalidVerificationID.message"
        ),
        type: "error",
      });
      break;
    case "auth/auth-domain-config-required":
      showMessage({
        title: i18n.global.t("login.errorsLogin.domainConfigRequired.title"),
        message: i18n.global.t(
          "login.errorsLogin.domainConfigRequired.message"
        ),
        type: "error",
      });
      break;
    case "auth/cancelled-popup-request":
      showMessage({
        title: i18n.global.t("login.errorsLogin.popupCancelled.title"),
        message: i18n.global.t("login.errorsLogin.popupCancelled.message"),
        type: "error",
      });
      break;
    case "auth/operation-not-supported-in-this-environment":
      showMessage({
        title: i18n.global.t("login.errorsLogin.operationNotSupported.title"),
        message: i18n.global.t(
          "login.errorsLogin.operationNotSupported.message"
        ),
        type: "error",
      });
      break;
    case "auth/popup-blocked":
      showMessage({
        title: i18n.global.t("login.errorsLogin.popupBlocked.title"),
        message: i18n.global.t("login.errorsLogin.popupBlocked.message"),
        type: "error",
      });
      break;
    case "auth/popup-closed-by-user":
      showMessage({
        title: i18n.global.t("login.errorsLogin.popupClosed.title"),
        message: i18n.global.t("login.errorsLogin.popupClosed.message"),
        type: "error",
      });
      break;
    case "auth/unauthorized-domain":
      showMessage({
        title: i18n.global.t("login.errorsLogin.unauthorizedDomain.title"),
        message: i18n.global.t("login.errorsLogin.unauthorizedDomain.message"),
        type: "error",
      });
      break;
    case "auth/provider-already-linked":
      showMessage({
        title: i18n.global.t("login.errorsLogin.providerAlreadyLinked.title"),
        message: i18n.global.t(
          "login.errorsLogin.providerAlreadyLinked.message"
        ),
        type: "error",
      });
      break;
    case "auth/invalid-credential":
      showMessage({
        title: i18n.global.t("login.errorsLogin.invalidCredential.title"),
        message: i18n.global.t("login.errorsLogin.invalidCredential.message"),
        type: "error",
      });
      break;
    case "auth/credential-already-in-use":
      showMessage({
        title: i18n.global.t("login.errorsLogin.credentialAlreadyUsed.title"),
        message: i18n.global.t(
          "login.errorsLogin.credentialAlreadyUsed.mesage"
        ),
        type: "error",
      });
      break;
    case "auth/invalid-verification-code":
      showMessage({
        title: i18n.global.t("login.errorsLogin.invalidVerificationCode.title"),
        message: i18n.global.t(
          "login.errorsLogin.invalidVerificationCode.message"
        ),
        type: "error",
      });
      break;
    case "auth/email-already-in-use":
      showMessage({
        title: i18n.global.t("login.errorsLogin.emailAlreadyUsed.title"),
        message: i18n.global.t("login.errorsLogin.emailAlreadyUsed.message"),
        type: "error",
      });
      break;
    case "auth/weak-password":
      showMessage({
        title: i18n.global.t("login.errorsLogin.weakPassword.title"),
        message: i18n.global.t("login.errorsLogin.weakPassword.message"),
        type: "error",
      });
      break;
    default:
      showMessage({
        title: i18n.global.t("login.errorsLogin.defaultError.title"),
        message: `${i18n.global.t(
          "login.errorsLogin.defaultError.message"
        )} ${error}`,
        type: "error",
      });
      break;
  }
};

export default handleLoginError;
